/**
 * Analytics MV2 QueryClient singleton.
 */
import { makeMv2QueryClient } from "@/features/_mv2/makeQueryClient";
import { ANALYTICS_QUERY_KEY, fetchAnalyticsFromApi } from "./analyticsQueryApi";

export const analyticsQueryClient = makeMv2QueryClient();

export function prefetchAnalytics({ start, end }) {
  if (!start || !end) return Promise.resolve();
  return analyticsQueryClient.prefetchQuery({
    queryKey: [ANALYTICS_QUERY_KEY, start, end],
    queryFn: ({ signal }) => fetchAnalyticsFromApi({ start, end }, signal),
  });
}
